import { createClient } from 'contentful';

const client = createClient({
  space: '7lqh82unq55r',         // Replace with actual space ID
  accessToken: 'UbUdprsXlKhVRO_9LoR-1RPoVHbzlwoZu3GBodtITJM' // Replace with actual access token
});

export default client;